import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/admin/social", label: "Dashboard", exact: true },
  { to: "/admin/social/manager", label: "Yönetici", exact: false },
  { to: "/admin/social/content-generator", label: "İçerik Üretici", exact: false },
  { to: "/admin/social/luna-settings", label: "Luna Ayarları", exact: false },
  { to: "/admin/social/connections", label: "Bağlantılar", exact: false },
];

export function AdminSocialSubNav() {
  const { pathname } = useLocation();
  return (
    <div className="mb-6 flex flex-wrap gap-1 rounded-2xl border border-slate-200 bg-white p-1 dark:border-slate-800 dark:bg-slate-950/40">
      {TABS.map((tab) => {
        const active = tab.exact ? pathname === tab.to : pathname.startsWith(tab.to);
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={cn(
              "rounded-xl px-4 py-1.5 text-sm font-medium transition-colors",
              active
                ? "bg-slate-900 text-white dark:bg-slate-50 dark:text-slate-900"
                : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200",
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
